import { Zeeguu_API } from "./classDef";
import qs from "qs";
import { getPlatform } from "../utils/misc/browserDetection";

// Consistent naming with other session types (reading, browsing, listening)
Zeeguu_API.prototype.exerciseSessionCreate = function (callback, onError) {
  const after_extracting_json = function (json) {
    let id = JSON.parse(json).id;
    callback(id);
  };
  return this._post(
    `exercise_session_start`,
    qs.stringify({ platform: getPlatform() }),
    after_extracting_json,
    onError
  );
};

Zeeguu_API.prototype.exerciseSessionUpdate = function (
  exerciseSessionId,
  currentDuration
) {
  let payload = {
    id: exerciseSessionId,
    duration: currentDuration * 1000, // the API expects ms
  };

  // Use beacon to prevent "Failed to fetch" errors when user navigates away
  this._postBeacon(`exercise_session_update`, qs.stringify(payload));
};

Zeeguu_API.prototype.exerciseSessionEnd = function (
  exerciseSessionId,
  totalTime
) {
  let payload = {
    id: exerciseSessionId,
    duration: totalTime * 1000,
  };

  // Use beacon to prevent "Failed to fetch" errors when user navigates away
  this._postBeacon(`exercise_session_end`, qs.stringify(payload));
};

// Backwards compatibility aliases (can be removed once all usages are migrated)
Zeeguu_API.prototype.startLoggingExerciseSessionToDB = function (callback) {
  this._post(
    `exercise_session_start`,
    qs.stringify({ platform: getPlatform() }),
    callback
  );
};

Zeeguu_API.prototype.updateExerciseSession = function (sessionId, duration) {
  this.exerciseSessionUpdate(sessionId, duration);
};

Zeeguu_API.prototype.reportExerciseSessionEnd = function (sessionId, totalTime) {
  this.exerciseSessionEnd(sessionId, totalTime);
};
